/* <soh-sticky-atc data-target="#MainAtc"> — visible while the main ATC is out of view; mirrors the selected option. */
class SohStickyAtc extends HTMLElement {
  connectedCallback() {
    const target = document.querySelector(this.dataset.target || '[data-main]');
    /* IntersectionObserver alone misses the jump from "below the fold" to "scrolled past" (no threshold crossed), so re-check on scroll too */
    const update = () => { if (!target) return; const r = target.getBoundingClientRect(); const show = r.bottom < 0; this.classList.toggle('is-visible', show); this.setAttribute('aria-hidden', String(!show)); };
    if (target && 'IntersectionObserver' in window) new IntersectionObserver(update).observe(target);
    let raf; addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    update();
    SOH.on('soh:option:change', ({ detail }) => {
      const o = detail.option;
      this.querySelectorAll('[data-sticky-label]').forEach(el => el.textContent = o.label + (o.selling_plan_id ? ' · ' + o.supply : ''));
      this.querySelectorAll('[data-sticky-price]').forEach(el => el.textContent = SOH.money(o.price));
    });
  }
}
customElements.define('soh-sticky-atc', SohStickyAtc);
